import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initPostHog, pageview, identify } from '../lib/analytics/posthog'
import { useAuth } from '../hooks/use-auth'

const AnalyticsProvider = () => {
  const location = useLocation()
  const { user } = useAuth()

  // init once
  useEffect(() => { initPostHog() }, [])

  // pageviews on route change
  useEffect(() => { pageview({ path: location.pathname }) }, [location.pathname])

  // identify when user available
  useEffect(() => {
    if (user?.id) {
      identify(user.id, {
        email: user.email,
        name: user.name,
        plan: user.plan,
        onboardingCompleted: user.onboardingCompleted,
        creditsCap: user.creditsCap,
        creditsUsed: user.creditsUsed,
      })
    }
  }, [user])

  return null
}

export default AnalyticsProvider
